import {apiHost, env} from '@/config';
import {
  APPLICATION_NAME,
  CSRF_COOKIE_NAME,
  ENVIRONMENTS,
  GOOGLE_ANALYTICS_CODES,
  SENTRY_TRACKING_URLS,
  SPINNER_LOGO,
  WIDGET_ID,
} from '@/constants';

export {
  apiHost,
  env,
  APPLICATION_NAME,
  CSRF_COOKIE_NAME,
  SPINNER_LOGO,
  WIDGET_ID,
};

export const isDevelopment = env === ENVIRONMENTS.DEVELOPMENT;

export const GOOGLE_ANALYTICS_CODE = GOOGLE_ANALYTICS_CODES[env];

export const SENTRY_TRACKING_URL = SENTRY_TRACKING_URLS[env];
